<div class="sx-contract-item">
  <div class="sx-contract-item__agreement">
    <div class="">
      <app-epi-content-display [information]="(epiContent$|async)"></app-epi-content-display>
    </div>
  </div>
</div>